import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SavedCardDto} from "../../models/saved-card.models";
import {SavedCardService} from "../../../../services/saved-card.service";
import {ContextMenuService} from "../../../../services/context-menu.service";

@Component({
  selector: 'app-saved-card-context-menu',
  templateUrl: './saved-card-context-menu.component.html',
  styleUrls: ['./saved-card-context-menu.component.scss']
})
export class SavedCardContextMenuComponent {
  @Input() item: SavedCardDto | undefined

  @Output() deleteCardEvent: EventEmitter<SavedCardDto> = new EventEmitter<SavedCardDto>()


  constructor(
    private savedCardService: SavedCardService,
    private contextMenuService: ContextMenuService
  ) {
  }

  makeMain(id: string) {
    this.savedCardService.makeMainCard$.next(id)
    this.contextMenuService.statusMenu$.next(false)
  }

  blockedCard(id: string) {
    this.savedCardService.blockedCard$.next(id)
    this.contextMenuService.statusMenu$.next(false)
  }

  activatedCard(id: string) {
    this.savedCardService.activatedCard$.next(id)
    this.contextMenuService.statusMenu$.next(false)
  }

  deleteCard(item: SavedCardDto) {
    this.deleteCardEvent.emit(item)
    this.contextMenuService.statusMenu$.next(false)
  }
}
